const SET_HAPPENING = 'SET_HAPPENING';
const SET_HAPPENING_NON_CONTENT = 'SET_HAPPENING_NON_CONTENT';
const RESET_HAPPENING_IS_INITIALIZED = 'RESET_HAPPENING_IS_INITIALIZED';
const SET_FILTERED_EVENTS = 'SET_FILTERED_EVENTS';
const SET_HAPPENING_RESERVATIONS_CONTENT = 'SET_HAPPENING_RESERVATIONS_CONTENT';

export {
    SET_HAPPENING, SET_HAPPENING_NON_CONTENT, RESET_HAPPENING_IS_INITIALIZED, SET_FILTERED_EVENTS, SET_HAPPENING_RESERVATIONS_CONTENT
};
